const DEFAULT_MAP_CENTER = { lat: 39.5, lng: -3.5 };
const DEFAULT_MAP_ZOOM = 5;

const toFiniteNumber = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value === 'string') {
        const parsed = Number(value.trim().replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : null;
    }
    return null;
};

const normalizeLatLng = (coords, fallback = DEFAULT_MAP_CENTER) => {
    const lat = toFiniteNumber(coords?.lat ?? coords?.latitude);
    const lng = toFiniteNumber(coords?.lng ?? coords?.long ?? coords?.lon ?? coords?.longitude);

    if (lat === null || lng === null) return fallback;

    return { lat, lng };
};

const normalizeMapCenter = (coords) => normalizeLatLng(coords, DEFAULT_MAP_CENTER);

const normalizeMapZoom = (zoom) => toFiniteNumber(zoom) ?? DEFAULT_MAP_ZOOM;

const normalizeMapBounds = (bounds) => {
    if (!bounds) return null;

    const north = toFiniteNumber(bounds.north);
    const south = toFiniteNumber(bounds.south);
    const east = toFiniteNumber(bounds.east);
    const west = toFiniteNumber(bounds.west);

    if ([north, south, east, west].some(value => value === null)) return null;

    return { ...bounds, north, south, east, west };
};

const getAlertPosition = (alert, fallback = null) => {
    const directPosition = normalizeLatLng(alert, null);
    if (directPosition) return directPosition;

    const nestedPosition = (
        normalizeLatLng(alert?.data, null) ||
        normalizeLatLng(alert?.location, null) ||
        normalizeLatLng(alert?.coords, null) ||
        normalizeLatLng(alert?.coordinates, null) ||
        normalizeLatLng(alert?.position, null)
    );
    if (nestedPosition) return nestedPosition;

    const locations = Array.isArray(alert?.locations) ? alert.locations : [];
    for (let i = locations.length - 1; i >= 0; i -= 1) {
        const locationPosition = normalizeLatLng(locations[i], null) || normalizeLatLng(locations[i]?.data, null);
        if (locationPosition) return locationPosition;
    }

    const reportLocations = Array.isArray(alert?.report?.locations) ? alert.report.locations : [];
    for (let i = reportLocations.length - 1; i >= 0; i -= 1) {
        const reportPosition = normalizeLatLng(reportLocations[i], null) || normalizeLatLng(reportLocations[i]?.data, null);
        if (reportPosition) return reportPosition;
    }

    return fallback;
};

export {
    DEFAULT_MAP_CENTER,
    DEFAULT_MAP_ZOOM,
    getAlertPosition,
    normalizeLatLng,
    normalizeMapBounds,
    normalizeMapCenter,
    normalizeMapZoom
};